const style = ({ COLORS }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  restrictOverlay: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    zIndex: '5',
    cursor: 'pointer'
  },
  cell: {
    width: 'calc(50% - 10px)',
    marginLeft: '20px',
    '&:first-child': {
      marginLeft: '0'
    }
  },
  labelsContainer: {
    marginBottom: '15px',
    display: 'flex',
    width: '100%',
    alignItems: 'flex-end'
  },
  label: {
    cursor: 'pointer',
    color: COLORS.TEXT.DARK_GREY.NORMAL
  },
  textareasContainer: {
    display: 'flex',
    width: '100%'
  },
  notes: {
    width: '100%',
    height: '166px',
    resize: 'none'
  },
  publicNote: {
    backgroundColor: '#fff'
  },
  privateNote: {
    backgroundColor: '#FFF8CB'
  }
})

export default style
